import { StyledDropDown } from 'modules/components/layer01';
import React from 'react';
import * as ds from './dataService';
import { appFormUtil } from 'modules/common';


export type InspectionResultSelectFieldProps<T extends object> = {
  form: appFormUtil.InferReturn<T>;
  fieldName: keyof T;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: InspectionResultSelectFieldProps<T>) => {
  const { data } = ds.useQuery();
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}

    />
  );
};
